import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import App from './app.component';
import { setupInternationalization } from './i18n/configurations';
import './safari-viewport-height-fix';

setupInternationalization();

// istanbul ignore next
Modal.setAppElement('#app');

// istanbul ignore next
const root = createRoot(document.getElementById('app'));
// istanbul ignore next
root.render(App);
